<template>
  <div class="mobile-wrapper" v-if="storeMenu">
    <!--Coupons-->
    <shop-header :store-id="storeid" />
    <div class="content-padding-double" v-if="!(isGift)" />
    <div class="container-fluid mobile-menu-content">
      <ProductList :menu="JSON.parse(JSON.stringify(storeMenu))" />
    </div>
  </div>
</template>
<script>
import ProductList from "../giftproducts/GiftProductListMobile";
import ShopHeader from "../../../components/shop/partials/shopheaderMobile";
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  components: {
    ProductList,
    ShopHeader
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  async created() {},
  mounted() {
    this.setStore(this.storeid);
    this.initStore(this.storeid);
    this.getStoreMenu(this.storeid);
  },
  computed: {
    ...mapGetters(["storeMenu"])
  },
  methods: {
    ...mapMutations(["setStore"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage",
      "isGift"
    ]),
    filterCategory(menu, category) {
      let find = null;
      for (let index = 0; index < menu.Categories.length; index++) {
        const item = menu.Categories[index];
        if (item.Name.toLowerCase() == category.toLowerCase()) {
          find = item;
          break;
        }
      }
      menu.Categories = [find];
      this.storeMenu = menu;
    }
  }
};
</script>
